import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    databaseChartEmptyMessage, databaseChartTitle, poolChartTitle, poolEmptyMessage
} from '../_helpers/platform-health-metrics';
import { DatabaseBlock, DatabaseUsersBlock, RunningRequest, SessionsBlock } from '../_types/platform-health';

/// Pestaña "Base de datos": indicadores de BD, las gráficas de Base de datos y Pool elástico, y las
/// tablas de usuarios y sesiones. Solo se muestra cuando el usuario tiene PLATFORM_HEALTH.DATABASE
/// (el padre decide eso con el *ngIf del p-tabPanel), así que este componente no vuelve a comprobar
/// ese permiso.
///
/// Componente de presentación puro: no pide datos, no construye gráficas, no conoce el servicio. Por
/// eso "cortar sesión" tampoco se resuelve aquí: el clic solo se emite hacia arriba (killSession) con
/// la fila completa, y es el componente del panel quien conoce PlatformHealthService y
/// ConfirmationService y decide qué hacer con la confirmación y la llamada.
@Component({
    selector: 'app-platform-health-database',
    templateUrl: './platform-health-database.component.html',
    styleUrls: ['./platform-health-database.component.scss'],
    standalone: false
})
export class PlatformHealthDatabaseComponent {
    @Input() public database: DatabaseBlock | null = null;
    @Input() public users: DatabaseUsersBlock | null = null;
    @Input() public sessions: SessionsBlock | null = null;

    /// Oculta el botón de cortar sesión cuando el usuario no tiene PLATFORM_HEALTH.KILL_SESSION. Esto
    /// es solo estética: el control de acceso real está en el servidor, que vuelve a comprobar el
    /// permiso (y además el login protegido) antes de matar nada.
    @Input() public canKillSession = false;

    @Input() public databaseChart: any = null;
    @Input() public poolChart: any = null;

    @Input() public chartOptions: any = null;

    @Output() public killSession = new EventEmitter<RunningRequest>();

    public databaseChartTitle(): string {
        return databaseChartTitle(this.database);
    }

    public databaseChartEmptyMessage(): string {
        return databaseChartEmptyMessage(this.database);
    }

    public poolChartTitle(): string {
        return poolChartTitle(this.database);
    }

    public poolEmptyMessage(): string {
        return poolEmptyMessage(this.database);
    }

    public onKillClick(request: RunningRequest): void {
        this.killSession.emit(request);
    }
}
